import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { PairSuitabilityFeedbackService } from '../../service/pair-suitability-feedback.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
@Component({
  selector: 'app-pair-suitability-feedback-button',
  templateUrl: './pair-suitability-feedback-button.component.html',
  styleUrls: ['./pair-suitability-feedback-button.component.scss']
})
export class PairSuitabilityFeedbackButtonComponent
  implements OnInit, OnDestroy {
  @Input() workerMailAiId: string;
  @Input() projectMailAiId: string;
  @Input() page: string; // PageEnumsの値

  status: 'unset' | 'good' | 'bad' = 'unset';
  clicked = false;
  rewarded = false;
  thanksMessage: boolean;
  submittedPair$: Subscription;
  constructor(
    private pairSuitabilityFeedbackService: PairSuitabilityFeedbackService,
    private toastrService: ToastrService
  ) {}

  ngOnInit() {
    this.thanksMessage = localStorage.getItem('feedThanksMessage') !== 'true';
    this.submittedPair$ = this.pairSuitabilityFeedbackService.submittedPair$
      .asObservable()
      .subscribe(param => {
        if (
          param.ai_project_id === this.projectMailAiId &&
          param.ai_worker_id === this.workerMailAiId
        ) {
          this.status = param.suitable ? 'good' : 'bad';
        }
      });
  }
  ngOnDestroy() {
    this.submittedPair$.unsubscribe();
  }
  feedBack(suitable: boolean): void {
    if (this.thanksMessage) {
      this.toastrService.success('ありがとうございます！Qoalaが賢くなります');
      localStorage.setItem('feedThanksMessage', 'true');
      this.thanksMessage = false;
    }
    if (
      this.status === 'unset' &&
      this.workerMailAiId &&
      this.projectMailAiId
    ) {
      this.pairSuitabilityFeedbackService
        .feedBack(this.workerMailAiId, this.projectMailAiId, suitable, this.page)
        .subscribe({
          next: res => {
            const total_feedback_count = res.body.total_feedback_count;
            if (total_feedback_count % 10 === 0) {
              this.toastrService.success(
                `ありがとうございます！${total_feedback_count}件目の評価です`
              );
              this.rewarded = true;
            }
          }
        });
      this.clicked = true;
    }
    this.status = suitable ? 'good' : 'bad';
  }
}
